<template>
  <div>
    <partHeader :title="title"></partHeader>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="150px"
    >
      <el-row>
        <el-col :span="16">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="identityNumber">
              <el-input
                v-model="form.identityNumber"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="form.gender" :disabled="disabled">
                <el-option
                  v-for="item in options.genderList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生地" prop="birthPlace">
              <el-input
                v-model="form.birthPlace"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族" prop="nation">
              <el-select v-model="form.nation" :disabled="disabled">
                <el-option
                  v-for="item in options.nationList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生年月" prop="birthDate">
              <el-date-picker
                v-model="form.birthDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                :disabled="disabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌" prop="politicsFace">
              <el-select v-model="form.politicsFace" :disabled="disabled">
                <el-option
                  v-for="item in options.politicsFaceList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入党时间" prop="joinPartyDate">
              <el-date-picker
                v-model="form.joinPartyDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                :disabled="disabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="telPhone">
              <el-input
                v-model="form.telPhone"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="form.contactPhone"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="家庭住址" prop="homeAddress">
              <el-input
                v-model="form.homeAddress"
                placeholder="请输入"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col :span="8">
          <div class="baseinfo-image">
            <img class="image" :src="form.imageSrc" />
            <el-upload
              action=""
              :on-change="imageChange"
              :show-file-list="false"
              :auto-upload="false"
            >
              <el-button size="small" type="primary" v-show="!disabled"
                >上传图片</el-button
              >
            </el-upload>
            <div class="red" :class="{ show: showMessage, hide: !showMessage }">
              请上传照片
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<style lang="scss" scoped>
.baseinfo-image {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  .image {
    margin: 10px;
    padding: 20px;
    width: 150px;
    height: 180px;
  }
}
.red {
  color: #f56c6c;
}
.show {
  display: block;
}
.hide {
  display: none;
}
</style>
<script>
import partHeader from "./partHeader.vue";
import share from "@/assets/sharejs/share.js";
export default {
  components: {
    partHeader,
  },
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "基本信息",
      validated: false,
      showMessage: false, //是否显示必须信息
      form: {
        jlxxid: "", //简历信息id
        identityNumber: "", //身份证号
        name: "", //姓名
        gender: "", //性别
        birthPlace: "", //出生地
        nation: "", //民族
        birthDate: "", //出生年月
        politicsFace: "", //政治面貌
        joinPartyDate: "", //入党时间
        telPhone: "", //手机号
        contactPhone: "", //联系电话
        homeAddress: "", //家庭住址
        imageSrc: "", //图片
      },
      rules: {
        identityNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthPlace: [
          { required: true, message: "请输入出生地", trigger: "blur" },
        ],
        nation: [{ required: true, message: "请选择民族", trigger: "blur" }],
        birthDate: [
          { required: true, message: "请选择出生年月", trigger: "blur" },
        ],
        politicsFace: [
          { required: true, message: "请选择政治面貌", trigger: "blur" },
        ],
        // joinPartyDate: [
        //   { required: true, message: "请选择入党时间", trigger: "blur" }
        // ],
        telPhone: [
           {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            type: "string",
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur"
          }
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        homeAddress: [
          { required: true, message: "请输入家庭住址", trigger: "blur" },
        ],
      },
      options: {
        genderList: share.get("xb"),
        nationList: share.get("mz"),
        politicsFaceList: share.get("zzmm"),
      },
    };
  },
  watch: {
    "form.politicsFace": function (newValue) {
      if (newValue == "01") {
        this.$set(this.rules, "joinPartyDate", [
          {
            required: true,
            message: "请选择入党时间",
            trigger: ["blur", "change"],
          },
        ]);
      } else {
        this.$set(this.rules, "joinPartyDate", []);
      }
    },
    "form.imageSrc": function (newValue) {
      if (newValue == "") {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }
    },
  },
  mounted() {
    /* 如果不是新增 */
    if (!this.$route.params.isTj) {
      this.form.jlxxid = this.item.jlxxid;
      this.form.name = this.item.xm;
      this.form.identityNumber = this.item.yxzjhm;
      this.form.gender = this.item.xb;
      this.form.birthPlace = this.item.csd;
      this.form.nation = this.item.mz;
      this.form.birthDate = this.dateFormat(this.item.csrq);
      this.form.politicsFace = this.item.zzmm;
      this.form.joinPartyDate = this.dateFormat(this.item.rdsj);
      this.form.telPhone = this.item.sjhm;
      this.form.contactPhone = this.item.lxdh;
      this.form.homeAddress = this.item.jtzz;
      this.form.imageSrc = "data:image/png;base64," + this.item.zp;
    }
  },
  methods: {
    validate() {
      this.validateForm();
      if (this.validated) {
        let para = {
          jlxxid: this.form.jlxxid, //简历信息id
          xm: this.form.name, //姓名
          xb: this.form.gender, //性别
          mz: this.form.nation, //民族
          csrq: this.form.birthDate, //出生日期
          csd: this.form.birthPlace, //出生地
          zzmm: this.form.politicsFace, //政治面貌
          rdsj: this.form.joinPartyDate, //入党时间
          yxzjhm: this.form.identityNumber, //有效证件号码
          sjhm: this.form.telPhone, //手机号码
          lxdh: this.form.contactPhone, //联系电话
          jtzz: this.form.homeAddress, //家庭住址
          zp: this.form.imageSrc.split(",")[1], //照片
        };
        return para;
      } else {
        return null;
      }
    },
    validateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      });
      if (this.form.imageSrc == "") {
        this.showMessage = true;
        this.validated = false;
        return;
      } else {
        this.showMessage = false;
      }
    },
    imageChange(file) {
      const isLt2M = file.size / 1024 / 1024 < 0.1;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 100kb!");
      }
      if (isLt2M) {
        let that = this;
        this.getBase64(file.raw).then((src) => {
          that.form.imageSrc = src;
        });
      }
      // fileList = [];
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let imageSrc;
        reader.readAsDataURL(file);
        reader.onload = function () {
          imageSrc = reader.result;
        };
        reader.onloadend = function () {
          resolve(imageSrc);
        };
        reader.onerror = function (err) {
          reject(err);
        };
      });
    },
    reset() {
      this.$refs.form.resetFields();
    },
    dateFormat(date) {
      if (date) {
        return (
          date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2)
        );
      }
      return "";
    },
  },
};
</script>
